import React from "react";
import {Card, Grid, IconButton, List, ListItem, ListItemButton, ListItemText, Toolbar} from "@mui/material";
import {ArrowBack} from "@mui/icons-material";
import {RootGrid, HeaderTypography} from "./containers/taxonomy";
import {pocPrimary, pageContentGap} from "../../../../theme";
import {Link} from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Auth from "../../../../auth";

interface SettingsProps {
    setTitle?: (title: string) => void;
    location: { key?: string };
    history: { push: (path: string) => void; goBack: () => void };
}

const CONNECTOR_DESCRIPTION = "Select which attribute updates you would like to automatically receive in your external system (ex. Shopify).";
const AUTO_APPROVE_DESCRIPTION = "Automatically approve all updates for a product when any of the specified attributes are updated by your suppliers.";

const iconButtonSx = () => ({
    backgroundColor: "white",
    border: "none",
    borderRadius: "6px",
    "& svg": { color: "rgba(0, 0, 0, 0.54)" }
});

export default function Settings(props: SettingsProps) {
    const hasInventoryManagePermission = Auth.hasPermission("inventory/manage");
    React.useEffect(() => {
        if (props.setTitle) {
            props.setTitle('POC Settings');
        }
    }, [props]);
    return (
        <RootGrid container
              style={{padding: "24px 14px 24px 14px", position: "relative"}}>
            <Grid container justifyContent={"space-between"} direction={"row"}>
                <Grid container justifyContent={"flex-start"} alignItems={"center"} style={{gap: pageContentGap, width: "100%"}}>
                    <IconButton
                        sx={iconButtonSx}
                        style={{height: "36px", width: "36px"}}
                        onClick={(e) => {
                            e.preventDefault();
                            if (props.location.key === undefined)
                                props.history.push("/productonboardingcenter/catalog");
                            else
                                props.history.goBack();
                        }}
                        size="large">
                        <ArrowBack style={{height: "18px", width: "18px"}}/>
                    </IconButton>
                    <HeaderTypography>
                        Settings
                    </HeaderTypography>
                </Grid>
            </Grid>
            <Grid size={12}>
                <Card>
                    <Toolbar className='lbtoolbar'
                             style={{background: pocPrimary}}
                    >
                        Product Onboarding Settings
                    </Toolbar>
                    <List style={{padding: 0}}>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to='/productonboardingcenter/settings/taxonomy'>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Taxonomy"
                                              secondary='View and manage your categories, attributes and attribute sets.'/>
                                <ArrowForwardIosIcon color="action"/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to={'/productonboardingcenter/settings/general'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="General"
                                              secondary='Configure settings around how you store and receive data.'/>
                                <ArrowForwardIosIcon color="action"/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to={'/productonboardingcenter/settings/connector'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Connector Configurations"
                                              secondary={CONNECTOR_DESCRIPTION}/>
                                <ArrowForwardIosIcon color="action"/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to={'/productonboardingcenter/settings/auto-approve'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}}
                                              primary="Auto Approve Attribute Changes"
                                              secondary={AUTO_APPROVE_DESCRIPTION}/>
                                <ArrowForwardIosIcon color="action"/>
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton component={Link} to={'/productonboardingcenter/settings/auto-ignore'}>
                                <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Auto Ignore Attribute Changes"
                                              secondary='Automatically ignore any updates sent by your suppliers for the specified attributes.'/>
                                <ArrowForwardIosIcon color="action"/>
                            </ListItemButton>
                        </ListItem>
                        {hasInventoryManagePermission && (
                            <ListItem disablePadding>
                                <ListItemButton component={Link} to={'/productonboardingcenter/settings/bulk-actions'}>
                                    <ListItemText style={{color: 'rgba(0, 0, 0, 0.87)'}} primary="Bulk Actions"
                                                  secondary='Complete actions in bulk.'/>
                                    <ArrowForwardIosIcon color="action"/>
                                </ListItemButton>
                            </ListItem>
                        )}
                    </List>
                </Card>
            </Grid>
        </RootGrid>
    );
}
